import React from 'react';
import './SøknaderOgSkjemaer.css';
import { Lenke } from '../../GeneriskeElementer/Lenke';
import { InternalLenkepanel, Lenkepanel } from '../../GeneriskeElementer/Lenkepanel';
import { navtjenester } from '../../altinn/tjenester';
import { HoyreChevron } from '../../GeneriskeElementer/HoyreChevron';
import { Heading } from '@navikt/ds-react';
import { gittMiljo } from '../../utils/environment';

import { useOrganisasjonsDetaljerContext } from '../OrganisasjonsDetaljerContext';

export const SøknaderOgSkjemaer = () => {
    const { valgtOrganisasjon } = useOrganisasjonsDetaljerContext();
    const tilgangEndreKontoummer =
        valgtOrganisasjon.altinntilgang.endreBankkontonummerForRefusjoner;
    const tilgangYrkesskade = valgtOrganisasjon.altinntilgang.yrkesskade;

    const lenke = (tekst: string, href: string, target?: string) => (
        <li>
            <Lenkepanel href={href} target={target}>
                {tekst}
            </Lenkepanel>
        </li>
    );

    return (
        <div className="skjemaveileder-container">
            <Heading
                size="small"
                level="2"
                id="skjemaveileder-tittel"
                className="skjemaveileder-tittel"
            >
                Søknader og skjemaer
            </Heading>

            <ul>
                {lenke(
                    'Søknad om fritak fra arbeidsgiverperioden - gravid ansatt',
                    gittMiljo({
                        prod: 'https://arbeidsgiver.nav.no/fritak-agp/nb/gravid/soknad',
                        other: 'https://arbeidsgiver.intern.dev.nav.no/fritak-agp/nb/gravid/soknad',
                    })
                )}

                {lenke(
                    'Søknad om fritak fra arbeidsgiverperioden - kronisk sykdom',
                    gittMiljo({
                        prod: 'https://arbeidsgiver.nav.no/fritak-agp/nb/kronisk/soknad',
                        other: 'https://arbeidsgiver.intern.dev.nav.no/fritak-agp/nb/kronisk/soknad',
                    })
                )}

                {valgtOrganisasjon.altinntilgang.refusjonskravSykepengerAGP ? (
                    <>
                        {lenke(
                            'Refusjonskrav sykepenger i arbeidsgiverperioden - gravid ansatt',
                            gittMiljo({
                                prod: 'https://arbeidsgiver.nav.no/fritak-agp/nb/gravid/krav',
                                other: 'https://arbeidsgiver.intern.dev.nav.no/fritak-agp/nb/gravid/krav',
                            })
                        )}

                        {lenke(
                            'Refusjonskrav sykepenger i arbeidsgiverperioden - kronisk sykdom',
                            gittMiljo({
                                prod: 'https://arbeidsgiver.nav.no/fritak-agp/nb/kronisk/krav',
                                other: 'https://arbeidsgiver.intern.dev.nav.no/fritak-agp/nb/kronisk/krav',
                            })
                        )}
                    </>
                ) : null}

                {valgtOrganisasjon.altinntilgang.inntektsmeldingSykdomIFamilien ? (
                    <>
                        {lenke(
                            'Refusjonskrav omsorgspenger',
                            gittMiljo({
                                prod: `https://arbeidsgiver.nav.no/k9-im-dialog/refusjon-omsorgspenger/${valgtOrganisasjon.organisasjon.orgnr}/1-intro`,
                                other: `https://arbeidsgiver.intern.dev.nav.no/k9-im-dialog/refusjon-omsorgspenger/${valgtOrganisasjon.organisasjon.orgnr}/1-intro`,
                            })
                        )}
                    </>
                ) : null}

                {valgtOrganisasjon.altinntilgang.ekspertbistand
                    ? lenke(
                          'Tilskudd til ekspertbistand',
                          gittMiljo({
                              prod: 'https://arbeidsgiver.nav.no/ekspertbistand',
                              demo: 'https://arbeidsgiver-dev.ansatt.dev.nav.no/ekspertbistand',
                              other: 'https://arbeidsgiver.intern.dev.nav.no/ekspertbistand',
                          })
                      )
                    : null}
                {valgtOrganisasjon.altinntilgang.permitteringOgNedbemanning
                    ? lenke(
                          'Skjema til NAV om permitteringer, oppsigelser, eller innskrenkning i arbeidstid',
                          gittMiljo({
                              prod: 'https://arbeidsgiver.nav.no/permittering/',
                              demo: 'https://arbeidsgiver.ansatt.dev.nav.no/permittering',
                              other: 'https://permitteringsskjema.intern.dev.nav.no/permittering/',
                          })
                      )
                    : null}
                {tilgangYrkesskade
                    ? lenke(
                          navtjenester.yrkesskade.navn,
                          gittMiljo({
                              prod: `https://skademelding.nav.no/yrkesskade/?bedrift=${valgtOrganisasjon.organisasjon.orgnr}`,
                              other: `https://skademelding.intern.dev.nav.no/yrkesskade/?bedrift=${valgtOrganisasjon.organisasjon.orgnr}`,
                          })
                      )
                    : null}
                {tilgangEndreKontoummer
                    ? lenke(
                          'Endre bankkontonummer for refusjoner fra NAV',
                          gittMiljo({
                              prod: `https://arbeidsgiver.nav.no/endre-kontonummer/`,
                              other: `https://sokos-kro-selvbetjening-frontend.ekstern.dev.nav.no/endre-kontonummer/`,
                          })
                      )
                    : null}
                {valgtOrganisasjon.altinntilgang.inntektsmeldingSykdomIFamilien ||
                valgtOrganisasjon.altinntilgang.inntektsmeldingSykepenger ||
                valgtOrganisasjon.altinntilgang.inntektsmeldingForeldrepenger ? (
                    <li>
                        <InternalLenkepanel to={'/saksoversikt#opprett-inntektsmelding'}>
                            Opprett manuell inntektsmelding
                        </InternalLenkepanel>
                    </li>
                ) : null}
                {valgtOrganisasjon.altinntilgang.oppgiNarmesteleder
                    ? lenke(
                          'Oppgi nærmeste leder for sykmeldt ansatt',
                          gittMiljo({
                              prod: 'https://www.nav.no/arbeidsgiver/ansatte/narmesteleder',
                              other: 'https://www.ekstern.dev.nav.no/arbeidsgiver/ansatte/narmesteleder',
                          })
                      )
                    : null}
                {valgtOrganisasjon.altinntilgang.utsendtArbeidstakerEØS
                    ? lenke(
                          navtjenester.utsendtArbeidstakerEØS.navn,
                          gittMiljo({
                              prod: 'https://www.nav.no/medlemskap-lovvalg/soknad',
                              other: 'https://melosys-skjema-web.intern.dev.nav.no/medlemskap-lovvalg/soknad',
                          })
                      )
                    : null}
            </ul>
            <div>
                <Lenke href={'https://www.nav.no/soknader/nb/bedrift'}>
                    Alle søknader og skjemaer
                    <HoyreChevron />
                </Lenke>
            </div>
        </div>
    );
};
